import { Alert, Col, Row, Table, Tabs } from "antd"
import {useContext, useState} from "react";
import { TabPane } from "semantic-ui-react"
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import {TemplateContext} from "../../../../utils/template_context";

export const Experiencia = ({ jurado }: any) => {
    const context = useContext(TemplateContext);
    const columnsProfesional: any = [
        {
            title: "No.",
            width: 40,
            render: (datos: any, datos2: any, index: number) => {
                return (
                        <span>{index + 1}</span>
                );
            },
            fixed: context.device === "md"? "left": false,
        },
        {
            title: "Nombre entidad",
            width: 200,
            dataIndex: "nombre",
            key: "nombre",
        },
        {
            title: "Fecha de inicio",
            width: 140,
            dataIndex: "fecha_inicio",
            key: "fecha_inicio",
        },
        {
            title: "Fecha de terminación",
            width: 140,
            dataIndex: "fecha_terminacion",
            key: "fecha_terminacion",
        },
        {
            title: "Cargo/Rol desempeñado",
            width: 140,
            dataIndex: "cargo",
            key: "cargo",
        },
        // {
        //     title: "Anexo",
        //     width: 140,
        //     render: (datos: any) => (
        //         <a role="button" tabIndex={0} className="button-azul-ghost" onClick={() => modalAnexo(datos)}>Anexo</a>
        //     )
        // },
    ];
    const columnsJurado: any = [
        {
            title: "No.",
            width: 40,
            render: (datos: any, datos2: any, index: number) => {
                return (
                        <span>{index + 1}</span>
                );
            },
            fixed: context.device === "md"? "left": false,
        },
        {
            title: "Nombre convocatoria",
            width: 200,
            dataIndex: "nombre_convocatoria",
            key: "nombre_convocatoria",
        },
        {
            title: "Entidad",
            width: 140,
            dataIndex: "entidad",
            key: "entidad",
        },
        {
            title: "Ciudad",
            width: 140,
            dataIndex: "ciudad",
            key: "ciudad",
        },
        {
            title: "Año",
            width: 140,
            dataIndex: "anio",
            key: "anio",
        },
        {
            title: "Expresión",
            width: 140,
            dataIndex: "area",
            key: "area",
        },
        // {
        //     title: "Anexo",
        //     width: 140,
        //     render: (datos: any) => (
        //         <a role="button" tabIndex={0} className="button-azul-ghost" onClick={() => modalAnexo(datos)}>Anexo</a>
        //     )
        // },
    ];

    const [openModal, setOpenModal] = useState(false);
    const [documento] = useState('')

    return (
        <>
            <Tabs defaultActiveKey="1" >
                <TabPane tab="Experiencia profesional" key="1">
                    {jurado.experiencias_profesionales !== null && jurado.experiencias_profesionales.length !== 0 ?
                        (
                            <Row>
                                <Col>
                                    <Table
                                        dataSource={jurado.experiencias_profesionales}
                                        columns={columnsProfesional}
                                        scroll={{ x: 1500, y: 300 }}
                                        pagination={false}

                                    />
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <Alert
                                message="No se han diligenciados datos para está sección"
                                type="warning"

                            />
                        )
                    }

                </TabPane>
                <TabPane tab="Experiencia en formulación, ejecución y evaluación de proyectos" key="2">
                    {jurado.experiencias ?
                        (
                            <Row>
                                <Col>
                                    <Table
                                        dataSource={jurado.experiencias}
                                        columns={columnsJurado}
                                        scroll={{ x: 1500, y: 300 }}
                                        pagination={false}
                                    />
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <Alert
                                message="No se han diligenciados datos para está sección"
                                type="warning"

                            />
                        )
                    }
                </TabPane>
            </Tabs>
            {openModal &&
                <ModalVisualizarDocumentos
                    visualizar={openModal}
                    setVisualizar={setOpenModal}
                    state={{ documento }}
                />
            }
        </>
    )
}
